import axios from 'axios';
import $ from "jquery";

const isLocal = (location.hostname === "localhost" || location.hostname === "127.0.0.1" || location.hostname === "");

const form = $('.form__participation');
if (form.length) {
    const formParticipation = $('#formParticipation'),
          btnSend = $('#btnSend'),
          email = document.querySelector('#userEmail'),
          checkbox = $('#check1'),
          emailReg = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;

    function setError(e, status) {
        if (status) {
            $(e).addClass('is-error')
            $(e).closest(".form__field").find('.form__error').removeClass('hidden')
        } else {
            $(e).removeClass('is-error')
            $(e).closest(".form__field").find('.form__error').addClass('hidden')
        }
    }

    function toggleModal(id, action) {
        const modal = document.getElementById(id);
        if (!modal) return;

        const modalClose = modal.querySelector(".modal__close");
        const modalOverlay = modal.querySelector(".modal__overlay");

        [modalOverlay, modalClose].forEach((el) => {
            el.addEventListener("click", () => {
                toggleModal(id, "close");
                $(formParticipation).removeClass("is-sending");
            });
        });

        if (action === "open") {
            document.body.classList.toggle("show-modal");
            modal.classList.add("is-open");
        } else {
            document.body.classList.remove("show-modal");
            modal.classList.remove("is-open");
        }
    }

    function formHandler() {
        const formSubmitUrl = form[0].dataset.formSubmit;

        function checkFormatEmail() {
            if (email.value.includes('+') && !email.value.startsWith('chatchai.devtest+')) {
                toggleModal("emailFormat", "open");
                return false;
            }
            return true;
        }

        function checkFormFieldsStep2() {
            if($(email).val().trim() === '' || !emailReg.test($(email).val().trim())){
                setError(email,true);
                return false;
            }
            if (!$(checkbox).prop('checked')) {
                setError(checkbox, true);
                return false;
            }
            return true;
        }

        $(email).on('change', ()=>{
            if($(email).val().trim() === ''){
                setError(email, true);
            } else {
                setError(email, false);
            }
        })

        $(checkbox).on('change', ()=>{
            if($(checkbox).prop('checked')){
                setError(checkbox, false);
            }
        })

        function collectAnswersFromLocalStorage() {
            const answers = [];

            for (let i = 0; i < localStorage.length; i++) {
                const key = localStorage.key(i);

                if (key.startsWith("question_")) {
                    const formId = key.replace("question_", "");
                    const questionId = parseInt(localStorage.getItem(key), 10);
                    const answerKey = `answer_${formId}`;
                    const optionId = parseInt(localStorage.getItem(answerKey), 10);

                    if (!isNaN(questionId) && !isNaN(optionId)) {
                        answers.push({
                            question_id: questionId,
                            option_id: optionId
                        });
                    }
                }
            }

            answers.sort((a, b) => a.question_id - b.question_id);

            return answers;
        }

        function clearLocalStorage() {
            localStorage.removeItem("barcode");

            const keysToRemove = [];

            for (let i = 0; i < localStorage.length; i++) {
                const key = localStorage.key(i);
                if (key.startsWith("question_step") || key.startsWith("answer_step")) {
                    keysToRemove.push(key);
                }
            }

            keysToRemove.forEach(key => localStorage.removeItem(key));
        }

        $(btnSend).on('click', async function(e){
            e.preventDefault()
            if(!checkFormFieldsStep2()) return;
            if (!checkFormatEmail()) return;

            const token = await grecaptcha.execute(tokenCaptcha, {
                action: "submit",
            });

            const newFormData = {
                product_code: localStorage.getItem("barcode"),
                answers: collectAnswersFromLocalStorage(),
                answer_to_tie_breaker_question: localStorage.getItem("question_step5"),
                email: String($(email).val()),
                privacy_policy: Boolean($('#check1').prop('checked')),
                newsletter: Boolean($('#check2').prop('checked')),
                third_party_consent: Boolean($('#check2').prop('checked')),
                "g-recaptcha-response": token
            };

            $(formParticipation).addClass('is-sending');

            if(isLocal){
                for (var pair of Object.entries(newFormData)) {
                    console.log(pair[0] + ', ' + pair[1]);
                }
                toggleModal("invalidForm", "open");
                clearLocalStorage();
                return;
            }

            try {
                const response = await axios({
                    method: "post",
                    url: formSubmitUrl,
                    data: newFormData,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                if (response.status === 200) {
                    if (response.data?.already_participated) {
                        toggleModal("popupInfo", "open");
                        $(formParticipation).removeClass('is-sending');
                        return false;
                    }

                    if (!response.data.captcha_is_valid) {
                        toggleModal("invalidCaptcha", "open");
                        $(formParticipation).removeClass('is-sending');
                        return false;
                    }

                    if(response.data.redirect_url) {
                        clearLocalStorage();
                        window.location.href = response.data.redirect_url + '?lang=' + locale;
                    }
                } else {
                    toggleModal("invalidForm", "open");
                    $(formParticipation).removeClass('is-sending');
                }
            } catch (err) {
                console.log(err.message);
                $(formParticipation).addClass('is-error');
                setTimeout(() => {
                    $(formParticipation).removeClass('is-error');
                }, 2000);
            } finally {

            }
        })

    }
    formHandler();
}